// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"72280e2b","541":"eb0ffdcb","549":"87349276","676":"11195ef7","787":"f757fab0"}[chunkId] + ".chunk.js";
};